<mat-form-field appearance="outline" fxFill>
  <mat-label>{{ 'Legalization.DocumentType' | translate }}</mat-label>
  <input type="text" matInput [formControl]="legalizationDocumentTypeId" [matAutocomplete]="docTypeAuto">
  <mat-autocomplete #docTypeAuto="matAutocomplete" [displayWith]="displayFn">
    @for (option of filteredDocumentTypes$ | async; track option) {
      <mat-option [value]="option.Id">
        {{ option.Name }}
      </mat-option>
    }
  </mat-autocomplete>
  @if (legalizationDocumentTypeId.invalid && legalizationDocumentTypeId.touched) {
    <mat-error>
      {{ 'InvalidField' | translate }}
    </mat-error>
  }
</mat-form-field>
